export const getActiveStates = (statefulVariablesWithValues) =>
  statefulVariablesWithValues.reduce((acc, variable) => {
    const { value, stateset, quality = 1 } = variable;

    const states = [];
    let isActive = false;

    for (const state of stateset?.states || []) {
      const { trigger } = state;
      switch (trigger.condition) {
        case '=': {
          isActive = value === trigger.triggerValue;
          break;
        }
        case '<>': {
          isActive = value > trigger.triggerValue1 && value < trigger.triggerValue2;
          break;
        }
        case '>': {
          isActive = value > trigger.triggerValue;
          break;
        }
        case '<': {
          isActive = value < trigger.triggerValue;
          break;
        }
        case '<=': {
          isActive = value <= trigger.triggerValue;
          break;
        }
        case '>=': {
          isActive = value >= trigger.triggerValue;
          break;
        }
        default: {
          break;
        }
      }

      if (isActive) {
        states.push({ ...state, quality });
      }
    }
    return [...acc, ...states];
  }, []);

export function findActiveStatesForVariables(
  variables = [],
  lastVariableData = {},
  stateSets = []
) {
  const statefulVariablesWithValues = (variables || []).map((variable) => {
    const stateset = (stateSets || []).find((s) => s.id === variable.stateset_id);
    const [, value, quality] = lastVariableData?.[variable.id] || [];
    return { value, stateset, quality };
  });
  return getActiveStates(statefulVariablesWithValues);
}
